export default "__VITE_ASSET__96b205d4__"